export default __webpack_public_path__ + "9a3ea79c9dbca4476634c35b84abfe1b.png";